import React from 'react';
import clsx from 'clsx';
import { useI18n } from '@tribeplatform/react-components/i18n';
import { Card } from '@tribeplatform/react-ui-kit/Card';
export const IframeBlock = ({ src, height, title, hidden, }) => {
    const { $t } = useI18n();
    if (hidden) {
        return null;
    }
    if (!(src === null || src === void 0 ? void 0 : src.startsWith('https://'))) {
        return (React.createElement(Card, { className: "overflow-hidden" },
            title && (React.createElement("div", { className: "pb-4 sm:pb-6" },
                React.createElement(Card.Header, { title: title, size: "sm" }))),
            React.createElement("div", { className: "flex justify-center items-center", style: { height: `${height}px` } },
                React.createElement("div", { className: "px-4 py-5 sm:p-6" }, $t({
                    id: 'Blocks.Iframe.InvalidUrlError',
                    defaultMessage: 'Embed pages, documents, livestreams, and other interactive media in this block by entering a valid URL starting with “https://“',
                })))));
    }
    return (React.createElement(Card, { className: "overflow-hidden" },
        title && (React.createElement("div", { className: "pb-4 sm:pb-6" },
            React.createElement(Card.Header, { title: title, size: "sm" }))),
        React.createElement("div", null,
            React.createElement("iframe", { title: $t({ id: 'Generics.Block', defaultMessage: 'Block' }), src: src, className: clsx('border-none w-full', 'transition-opacity duration-300'), style: { height: `${height}px` } }))));
};
//# sourceMappingURL=Block.js.map